<template>
  <el-container>
    <el-main style="padding: 0; display: flex">
      <div style="width: 550px">
        <span>生产过程扫描</span>
        <el-divider/>
        <el-form
            ref="form"
            v-loading="submitLoading"
            style="width: 550px"
            :rules="ruleValidate"
            :model="model"
            class="form"
            label-width="90px"
            @submit.native.prevent>
          <el-form-item label="序列号" prop="materialSn">
            <el-input
                ref="materialSnInput"
                v-model="model.materialSn"
                placeholder="请扫描序列号"
                size="mini"
                @keyup.enter.native.stop="materialSnScan"/>
          </el-form-item>
          <el-form-item label="生产中心" prop="workCenterId">
            <el-input v-model="model.workCenterName" :disabled="!model.workCenterId" placeholder="请扫描序列号" readonly/>
          </el-form-item>
          <el-form-item label="产品工艺" prop="routeId">
            <el-input v-model="model.routingName" :disabled="!model.routeId" placeholder="请扫描序列号" readonly/>
          </el-form-item>
          <el-form-item label="工序" prop="processId">
            <el-select v-model="model.processId" :disabled="!model.routingName" placeholder="请选择工序" @change="processChange">
              <el-option v-for="item in processList" :key="item.pkid" :label="item.processName" :value="item.processId"/>
            </el-select>
          </el-form-item>
          <el-form-item v-if="productionType" label="工单数量" prop="quantity">
            <el-input v-model="model.quantity" disabled/>
          </el-form-item>
          <el-form-item v-if="productionType && model.processId" label="数量" prop="outputQuantity">
            <el-input
                ref="outputQuantityInput"
                v-model="model.outputQuantity"
                placeholder="请输入数量"
                size="mini"
                @keyup.enter.native.stop="quantityInput"/>
          </el-form-item>
          <el-form-item v-if="bindVehicleType && model.processId" label="载具编号" prop="vehicleNo">
            <el-input
                ref="vehicleNoInput"
                v-model="model.vehicleNo"
                placeholder="请扫描载具编号"
                size="mini"
                @keyup.enter.native.stop="complete = true"/>
          </el-form-item>
          <el-form-item v-if="complete" label="员工编号" prop="scannerNo">
            <el-input
                ref="scannerInput"
                v-model="model.scannerNo"
                placeholder="请扫描员工编号"
                size="mini"
                @keyup.enter.native.stop="scanMainSn"/>
          </el-form-item>
        </el-form>
        <span>部件扫描</span>
        <el-divider/>
        <Table
            style="width: 550px"
            border
            stripe
            :columns="columns"
            :data="model.partsScan">
          <template slot="partsSnSlot" slot-scope="{ row, index }">
            <el-input
                :ref="'input_' + index"
                v-model="row.partsSn"
                placeholder="请扫描部件条码"
                size="mini"
                @keyup.enter.native.stop="scanPartsn(row, index)"
            />
          </template>
        </Table>
      </div>
      <div v-if="esopFile" style="flex: 1; margin-left: 30px">
        <pdf-preview :pdf-url="esopFile" :esop-page-no="esopPageNo"/>
      </div>
    </el-main>
  </el-container>
</template>

<script>
  import PdfPreview from "@/components/PdfPreview";

  export default {
    components: {
      PdfPreview,
    },

    data() {
      return {
        submitLoading: false,
        complete: false,
        lastProcessId: "",
        lastRouteId: "",
        esopFile: "",
        esopPageNo: 1,
        productionType: "",
        bindVehicleType: "",
        processList: [],
        model: {
          workCenterName: "",
          workCenterId: "",
          routingName: "",
          routeId: "",
          processId: "",
          scannerNo: "",
          materialSn: "",
          outputQuantity: "",
          vehicleNo: "",
          partsScan: [],
          quantity: "",
          startTime: "",
        },
        columns: [
          {
            title: "部件条码",
            key: "partsSn",
            width: 160,
            align: "center",
            slot: "partsSnSlot",
          },
          {
            title: "部件编号",
            key: "partsNo",
            width: 160,
            align: "center",
          },
          {
            title: "部件名称",
            key: "partsName",
            tooltip: true,
          },
        ],
        ruleValidate: {
          workCenterId: [{ required: true, message: "请选择生产中心", trigger: "change" }],
          routeId: [{ required: true, message: "请选择工艺路线", trigger: "change" }],
          processId: [{ required: true, message: "请选择工序", trigger: "change" }],
          scannerNo: [{ required: true, message: "请扫描员工编号", trigger: "blur" }],
          materialSn: [{ required: true, message: "请扫描产品序列号", trigger: "blur" }],
          outputQuantity: [{ required: true, message: "请输入数量", trigger: "blur" }],
        },
      };
    },

    methods: {
      // 根据产品工艺pkid查询工序
      getProcess(pkid) {
        this.$http.get("basic", `rtRouteMaterials/process?masterId=${pkid}`).then((res) => {
          if (res.success) {
            this.processList = res.data.filter((item) => item.scanIndex === 1);
            if (this.lastRouteId === pkid && this.lastProcessId !== "") {
              this.model.processId = this.lastProcessId;
              this.processChange(this.model.processId);
            }
            if (this.lastRouteId !== pkid) {
              this.lastProcessId = "";
            }
            this.lastRouteId = pkid;
          }
        });
      },

      // 工序(选中值发生变化时触发)
      processChange(value) {
        this.lastProcessId = value;
        this.esopFile = "";
        this.esopPageNo = 1;
        this.complete = false;
        this.resetFiled(["outputQuantity", "vehicleNo", "scannerNo"]);
        const result = this.processList.find((item) => item.processId === value);
        if (result.esopId) {
          this.getEsopFile(result.esopId);
        }
        if (!this.productionType && !this.bindVehicleType) {
          this.complete = true;
          this.$nextTick(() => this.$refs.scannerInput.focus());
        }
        if (this.productionType) {
          this.$nextTick(() => this.$refs.outputQuantityInput.focus());
        } else if (this.bindVehicleType) {
          this.$nextTick(() => this.$refs.vehicleNoInput.focus());
        }
      },

      // 根据esop文件id查询文件服务器路径
      getEsopFile(esopId) {
        this.$http.get("basic", `esops/${esopId}`).then((resp) => {
          if (resp.success) {
            this.$http.get("basic", `files/getDownloadUrl?key=${resp.data.filePath}`).then((res) => {
              if (res.success) {
                this.esopFile = res.data;
              }
            });
          }
        });
      },

      // 扫描序列号 判断是否显示数量 载具编号
      materialSnScan() {
        if (this.model.materialSn) {
          this.resetOtherData();
          this.resetFiled(["routeId", "workCenterId", "processId", "quantity", "outputQuantity", "vehicleNo", "scannerNo"]);
          let param = {
            serialNo: this.model.materialSn,
          };
          this.$http.get("basic", "productionScan/selectPpScanBySerialNo", param).then((res) => {
            if (res.success) {
              this.model.quantity = res.data.quantity; // 工单数量
              this.productionType = res.data.productionType; // 是否显示工单数量、数量 1显示 0隐藏
              this.bindVehicleType = res.data.bindVehicleType; // 是否显示载具   1显示 0隐藏
              this.model.startTime = res.data.startTime;
              this.model.workCenterId = res.data.workCenterId;
              this.model.workCenterName = res.data.workCenterName;
              this.model.routeId = res.data.routeId;
              this.model.routingName = res.data.routingName;
              this.getProcess(this.model.routeId);
              this.$playScanSuccess();
            } else {
              this.$refs.form.resetFields();
              this.resetOtherData();
              this.$playScanFailure();
            }
          });
        }
      },

      quantityInput() {
        if (this.model.outputQuantity) {
          const reg = /^[1-9]\d*$/;
          if (!reg.test(this.model.outputQuantity) || this.model.outputQuantity > this.model.quantity) {
            this.$confirm(`数字不合法，请输入1-${this.model.quantity}之间的整数！`, "错误", {
              type: "error",
              showCancelButton: false,
            });
            this.resetFiled(["outputQuantity"]);
          } else if (this.bindVehicleType) {
            this.$nextTick(() => this.$refs.vehicleNoInput.focus());
          } else {
            this.complete = true;
            this.$nextTick(() => this.$refs.scannerInput.focus());
          }
        }
      },

      // 扫描主条码
      scanMainSn() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http.post("basic", "productionScan/scanMain", this.model).then((res) => {
              if (res.success) {
                this.esopFile = res.data.esopFile;
                this.esopPageNo = +res.data.esopPageNo;
                // 如果没有关键器件-> 扫描成功
                if (!res.data.items.length) {
                  this.$message.success("扫描成功");
                  this.$refs.form.resetFields();
                  this.resetOtherData();
                  this.$refs.materialSnInput.focus();
                  this.$playScanSuccess();
                } else {
                  // 如果有关键器件 判断是否批量完工  如果是批量完工 不显示 关键器件列表  如果是单件完工 则显示关键器件列表
                  this.model.partsScan = res.data.items;
                  this.$playScanFailure();
                  this.$nextTick(() => {
                    this.$refs["input_0"].focus();
                  });
                }
              } else {
                this.resetFiled(["scannerNo"]);
              }
              this.submitLoading = false;
            });
          }
        });
      },

      // 扫描部件条码
      scanPartsn(row, index) {
        if (row.partsSn) {
          this.$set(this.model.partsScan, index, row);
        }
        const arr = this.model.partsScan.filter((item) => !item.partsSn);
        if (!arr.length) {
          this.$http.post("basic", "productionScan/scanParts", this.model).then((resp) => {
            if (resp.success) {
              this.$message.success(resp.message);
              this.model.partsScan = [];
              this.$refs.form.resetFields();
              this.resetOtherData();
              this.$refs.materialSnInput.focus();
              this.$playScanSuccess();
            } else {
              this.$playScanFailure();
            }
          });
        }
        if (index !== this.model.partsScan.length - 1) {
          this.$refs["input_" + (index + 1)].focus();
        }
      },

      resetFiled(data) {
        data.forEach((item) => {
          let result = this.$refs.form.fields.find((f) => f.prop === item);
          if (result) {
            result.resetField();
          }
        });
      },

      resetOtherData() {
        this.complete = false;
        this.model.workCenterName = "";
        this.model.routingName = "";
        this.model.startTime = "";
        this.productionType = "";
        this.bindVehicleType = "";
        this.esopFile = "";
        this.esopPageNo = 1;
        this.processList = [];
      },
    },
  };
</script>
